import React, { useState } from 'react'
import classes from '../styles.module.scss';
import { useTranslation } from 'react-i18next';
import Tabs from '../../../components/tabs/tabs.component';



const links: Record<string, string> = {
  summaryData: 'https://app.powerbi.com/view?r=eyJrIjoiMDVhMTQxOTQtMWM0MC00ZDZhLWJmNDItMTA1YTk2NDdmYmM2IiwidCI6ImRlNzAxMmMyLTI0M2MtNDFjMi04NjRmLWE5YmEyMGY0YzUxOSIsImMiOjl9',
  // livestockProduction: 'https://app.powerbi.com/view?r=eyJrIjoiMDVhMTQxOTQtMWM0MC00ZDZhLWJmNDItMTA1YTk2NDdmYmM2IiwidCI6ImRlNzAxMmMyLTI0M2MtNDFjMi04NjRmLWE5YmEyMGY0YzUxOSIsImMiOjl9',
  // potentialIndustrialZones: 'https://app.powerbi.com/view?r=eyJrIjoiMDVhMTQxOTQtMWM0MC00ZDZhLWJmNDItMTA1YTk2NDdmYmM2IiwidCI6ImRlNzAxMmMyLTI0M2MtNDFjMi04NjRmLWE5YmEyMGY0YzUxOSIsImMiOjl9',
  // livestockSpecialization: 'https://app.powerbi.com/view?r=eyJrIjoiMDVhMTQxOTQtMWM0MC00ZDZhLWJmNDItMTA1YTk2NDdmYmM2IiwidCI6ImRlNzAxMmMyLTI0M2MtNDFjMi04NjRmLWE5YmEyMGY0YzUxOSIsImMiOjl9',
  // cropSpecialization: 'https://app.powerbi.com/view?r=eyJrIjoiMDVhMTQxOTQtMWM0MC00ZDZhLWJmNDItMTA1YTk2NDdmYmM2IiwidCI6ImRlNzAxMmMyLTI0M2MtNDFjMi04NjRmLWE5YmEyMGY0YzUxOSIsImMiOjl9',
}

const baseClass = 'programs';
const translationKey = 'programs'

const Programs = () => {
  const { t } = useTranslation();
  const tabs = [
    'summaryData',
    // 'livestockProduction',
    // 'potentialIndustrialZones',
    // 'livestockSpecialization',
    // 'cropSpecialization',
  ].map(key => ({
    key,
    label: t(`programs.${key}`)
  }))

  const [activeTab, setActiveTab] = useState<string>(tabs[0].key);
  return (
    <div className={classes[baseClass]}>
      <Tabs tabs={tabs} activeTab={activeTab} onTabChange={setActiveTab} />
      <iframe src={links[activeTab]} frameBorder="0" title={activeTab}/>
    </div>
  )
}

export default Programs